<div class="container pt-5">


    <div class="row">

        <!-- <div class="col-2 col-sm-8"></div>
        <div class="col-12 mt-2 mb-2">
            <h2 class="accent bold" style="font-size: 0.9970rem">
                <strong> Business Enroll</strong>
            </h2>
        </div> -->
    
    </div>



    <!-- Business Enroll  -->
    <form name="enrollFormBusiness" [formGroup]="enrollFormBusiness"
        (ngSubmit)="AddEnrollBusiness(enrollFormBusiness.value)">
        <div  class="row" autocomplete="off">

            <div class="col-12 mb-3">
                <h2 class="accent" style="font-size: 0.9970rem">Business Enrol Application</h2>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>ID Number <label style="color:red">*</label></mat-label>
                    <input matInput type="number" class="example-right-align" name="NIBNumber"
                        formControlName="NIBNumber" autocomplete="off"
                        onKeyPress="if(this.value.length==8) return false;">
                    <mat-error *ngIf="enrollFormBusiness.controls.NIBNumber.invalid">
                        ID Number should contain 8
                        characters
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Business Name <label style="color:red">*</label></mat-label>
                    <input matInput name="Bname" formControlName="Bname" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Trading As (optional) </mat-label>
                    <input matInput name="trading" formControlName="trading" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100 ">
                    <mat-label>Business Type <label style="color:red">* </label></mat-label>
                    <input matInput name="Btype" formControlName="Btype" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> Business Address <label style="color:red">*</label></mat-label>
                    <textarea matInput formControlName="Baddress" name="Baddress" type="text"></textarea>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> Business Email Address <label style="color:red">*</label></mat-label>
                    <input matInput formControlName="Bemailaddress" name="Bemailaddress" autocomplete="off">
                </mat-form-field>

            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Date of Inception <label style="color:red">*</label></mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="DateofInception" autocomplete="off"
                        readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">

            </div>

            <!-- Primary Contacts -->

            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Primary Contacts<label style="color:red"> </label> </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Name <label style="color:red">*</label></mat-label>
                            <input matInput formControlName="BPname" name="BPname">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Email Address <label style="color:red">*</label></mat-label>
                            <input matInput formControlName="BPemailaddress" name="BPemailaddress">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Phone <label style="color:red">*</label></mat-label>
                            <input matInput formControlName="BPphone" name="BPphone">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Secondary Contacts -->
            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Secondary Contacts </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Name </mat-label>
                            <input matInput formControlName="SBname" name="SBname">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Email Address</mat-label>
                            <input matInput formControlName="SBemailaddress" name="SBemailaddress">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Phone </mat-label>
                            <input matInput formControlName="SBphone" name="SBphone">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Banking Info -->
            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Banking Info </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Bank Name </mat-label>
                            <input matInput formControlName="Bbankname" name="Bbankname">
                        </mat-form-field>

                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Branch </mat-label>
                            <input matInput formControlName="Bbranch" name="Bbranch">
                        </mat-form-field>

                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Account Number </mat-label>
                            <input matInput formControlName="Baccountnumber" name="Baccountnumber">
                        </mat-form-field>

                    </div>

                </div>
            </div>





            <!-- Document's Upload -->

            <div class="col-8">
                <div class="row">
                    <h4 style="font-size: 0.9970rem"> Beneficial Owner details (articles of incorporation or equivalent)
                        <span class="text-muted"> <label style="color:red">
                                <h5 style="font-size: 0.9970rem">( JPG and PDF files are allowed)</h5>
                            </label></span>
                    </h4>
                    <div class="input-group w-100 mb-2">
                        <div class="custom-file">
                            <input type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
                                (change)="onFileChangeBeneficial($event)" accept="image/jpg,image/jpeg,application/pdf"
                                formControlName="beneficialdocs">
                            <label class="custom-file-label" for="inputGroupFile01">{{this.BeneficialfileInput}}</label>
                        </div>
                    </div>&nbsp;


                    <h4 style="font-size: 0.9970rem"> Authorized Signatories and specimen signatures
                        <span class="text-muted"> <label style="color:red">
                                <h5 style="font-size: 0.9970rem">( JPG and PDF files are allowed)</h5>
                            </label></span>
                    </h4>
                    <div class="input-group w-100 mb-2">
                        <div class="custom-file">
                            <input type="file" id="inputGroupFile02" aria-describedby="inputGroupFileAddon02"
                                (change)="onFileChangeAuthorized($event)" accept="image/jpg,image/jpeg,application/pdf"
                                formControlName="authorizeddocs">
                            <label class="custom-file-label" for="inputGroupFile02">{{this.AuthorizedfileInput}}</label>


                        </div>
                    </div>

                    <h4 style="font-size: 0.9970rem"> Business license/VAT registration
                        <span class="text-muted"> <label style="color:red">
                                <h5 style="font-size: 0.9970rem">( JPG and PDF files are allowed)</h5>
                            </label></span>
                    </h4>
                    <div class="input-group w-100 mb-2">
                        <div class="custom-file">
                            <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                                (change)="onFileChangeBusiness($event)" accept="image/jpg,image/jpeg,application/pdf"
                                formControlName="Businessdocs">
                            <label class="custom-file-label" for="inputGroupFile03">{{this.BusinessfileInput}}</label>


                        </div>
                    </div>

                </div>





            </div>






        </div>
        <div class="row">
            <div class="col-12">
                <button mat-flat-button type="submit" color="primary" class="loginbtn mr-2"
                    *ngIf="Business">Submit</button>

                <button mat-flat-button color="primary" class="loginbtn mr-2" [routerLink]="['/']" *ngIf="Business">
                    Cancel</button>

            </div>
        </div>
    </form>

</div>

<div class="mat-spinner-fullscreen" [hidden]="loadingData1">
    <mat-spinner style="margin:0 auto;" class="pink-spinner .mat-spinner-bar-buffer" mode="indeterminate">
    </mat-spinner>
</div>